import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { useGetCentersQuery } from '../../../../../services/ConfigurationService';
import { updateEstimateBasicInfo } from '../../../../../services/ContractService/contractEstimateSlice';
import { CenterType } from '../../../../../services/ConfigurationService/types/centerType';

export const EstimateCenterEditor: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  
  const dispatch = useAppDispatch();
  const estimate = useAppSelector(state => state.contractEstimate.currentEstimate);
  const errors = useAppSelector(state => state.contractEstimate.validationErrors);

  // Fetch centers data
  const { data: centers = [], isLoading: centersLoading } = useGetCentersQuery(
    { company },
    { skip: !company }
  );

  // Sort centers by shortName
  const sortedCenters = [...centers].sort((a, b) => a.shortName.localeCompare(b.shortName));

  const selectedCenter = sortedCenters.find(c => c.id === estimate?.centerId);

  const handleCenterChange = (center: CenterType | null) => {
    dispatch(updateEstimateBasicInfo({
      centerId: center?.id || '',
      centerCode: center?.code,
      centerName: center?.name,
      payerId: '', // Reset payer when center changes
      payerName: ''
    }));
  };

  return (
    <Autocomplete
      value={selectedCenter || null}
      onChange={(_, value) => handleCenterChange(value)}
      options={sortedCenters}
      getOptionLabel={(option) => `${option.code}-${option.shortName}`}
      loading={centersLoading}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Center"
          required
          error={!!errors.centerId}
          helperText={errors.centerId}
        />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={{ width: 220 }}
    />
  );
};